import { ApiError } from '../errors/api-error.js';

export class BackupService {
    constructor(api) {
        this.api = api;
    }

    async list() {
        return this._w(() => this.api.list(), 'Failed to list backups');
    }

    async run(body) {
        return this._w(() => this.api.run(body), 'Failed to run backup', 'Yedekleme başlatıldı');
    }

    async pbmList() {
        return this._w(() => this.api.pbmList(), 'Failed to list PBM backups');
    }

    async pbmStatus() {
        return this._w(() => this.api.pbmStatus(), 'Failed to load PBM status');
    }

    async pbmRun(body) {
        return this._w(() => this.api.pbmRun(body), 'Failed to start PBM backup', 'PBM yedekleme başlatıldı');
    }

    async pbmRestore(body) {
        return this._w(() => this.api.pbmRestore(body), 'Failed to restore', 'Geri yükleme başlatıldı');
    }

    async pbmDelete(body) {
        return this._w(() => this.api.pbmDelete(body), 'Failed to delete backup', 'Snapshot deleted');
    }

    async pbmResync() {
        return this._w(
            () => this.api.pbmResync(),
            'Failed to resync backup catalog',
            'Backup catalog resynced from storage',
        );
    }

    async getSchedule() {
        return this._w(() => this.api.getSchedule(), 'Failed to load backup schedule');
    }

    async updateSchedule(body) {
        return this._w(
            () => this.api.updateSchedule(body),
            'Failed to update backup schedule',
            'Backup schedule updated',
        );
    }

    async testStorage() {
        return this._w(() => this.api.testStorage(), 'Failed to test backup storage');
    }

    async updateStorage(body) {
        return this._w(
            () => this.api.updateStorage(body),
            'Failed to update backup storage',
            'Backup storage updated',
        );
    }

    async _w(fn, fb, okMsg) {
        try {
            const r = await fn();
            return {
                success: true,
                data: r?.data ?? r,
                message: r?.message || okMsg,
                warning: r?.warning,
            };
        } catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || fb, 500, 'UNKNOWN_ERROR', e);
        }
    }
}
